<label for="feature_{{feature.id}}">
  {{ feature.header }}<span *ngIf="feature.unitHeader">, {{ feature.unitHeader }}</span>
  <span *ngIf="isRequired()"> *</span>
  <span *ngIf="feature.comment" nbTooltip="{{feature.comment}}"><nb-icon icon="bulb-outline"></nb-icon></span>
</label>

<div class="accordion-item__right">
  <form [formGroup]="form" style="width: 100%;">
    <app-three-state-checkbox formControlName="featureValue"></app-three-state-checkbox>
  </form>
  <div class="accordion-item__right-info">
    <div class="state-warn" *ngIf="featureValue.valid && isShowEmptyWarning()">
      <nb-icon icon="alert-triangle-outline"/>
    </div>
    <div class="state-err" *ngIf="featureValue.invalid">
      <nb-icon icon="alert-circle-outline"/>
    </div>
    <div class="state-success" *ngIf="featureValue.valid && !isEmpty()">
      <nb-icon icon="checkmark-outline"/>
    </div>
    <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
       class="entityID"
       target="_blank"
       i18n-nbTooltip="@@OpenFeatureInNewWindow"
       nbTooltip="Открыть характеристику в новом окне"
       *ngIf="featureLink">
      #{{ feature.featureId }}
    </a>
  </div>
</div>

